<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                             Reports</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active"> Reports</li>
                                <!-- <li class="breadcrumb-item active" aria-current="page">
                                    {{'header.course-data.titleList.AddCourse' | translate }} </li> -->
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div>
                                <button type="button" [mat-dialog-close]="true"
                                    class="btn size btn-primary btn-icon-text floatright mt-1"
                                    (click)="Back()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/turn-left.gif"
                                            style="margin-right: 5px;">
                                        Back
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row row-sm add-form mt-4" >
                      
                        <div class="iframe-container">
                            <iframe id="reportIframe" height="400" class="mrg" src="assets/loader.html"></iframe>
                          </div>
                           <!--     <div class="container">
                               <h3>Embedding the PDF file Using Object Tag</h3>
                           </div> -->
                           
                   </div>
                    
                    <!-- list of Exam end  -->
                </div>
            </div>
        </div>
    </form>
</body>